import EditorVM from './editor-vm';
var self = this;

export default {
  init: function() {
    // self.addSelectEvents();
    var data = $('#institution_json').val();

    var validationOptions = Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS;
    var ele = document.getElementById('institution_edit_form');
    ko.applyBindingsWithValidation(new EditorVM(data, ele), ele, validationOptions);
  }
};

